// eslint-disable-next-line import/no-extraneous-dependencies
import Qs from 'qs'
import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

export const getSales = async (
  cancel: any,
  clienteId: number[],
  empresaId: number[],
  produtoId: number[],
  vendedorId: number[],
  dataFim: string,
  dataInicio: string,
  query: string | number,
  page: number,
  segmento: string[],
  categoria: string[]
): Promise<GetSalesType | { message: string }> => {
  try {
    const result = await apiService.get('app/venda', {
      cancelToken: cancel.token,
      params: {
        clienteId,
        empresaId,
        produtoId,
        vendedorId,
        segmento,
        categoria,
        dataFim,
        dataInicio,
        query,
        page: page - 1,
        size: 7,
      },
      paramsSerializer(paramsAux: any) {
        return Qs.stringify(paramsAux, { arrayFormat: 'repeat' })
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}
